import Styles from './ReviewTemplates.module.scss'
import { ReviewTemplate } from 'types'
import { IconButton } from 'components/IconButton/IconButton'
import { ReactComponent as DeleteIcon } from 'assets/icons/delete16-trash.svg'
import { useDeleteReviewTemplate } from 'hooks/queries/reviewTemplates/useDeleteReviewTemplate'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { Button } from 'components/Button/Button'

interface Props {
  template: ReviewTemplate
  className: string
}

export const DeleteButton = ({ template, className }: Props) => {
  const { mutate: deleteReviewTemplate } = useDeleteReviewTemplate({ workspaceId: template.workspace_id })

  return (
    <DropdownTrigger placement="top">
      <IconButton
        variant="tertiary"
        size="sm"
        icon={DeleteIcon}
        aria-label={`Delete ${template.name}`}
        iconClassName={Styles.iconButton}
        className={className}
      />
      {(close) => {
        const onSuccess = () => {
          showToastMessage('Template deleted')
          close()
        }
        const onError = () => {
          showToastMessage('Failed to delete template', 'error')
          close()
        }
        const handleDelete = () => deleteReviewTemplate(template.id, { onError, onSuccess })

        return (
          <div>
            <div className={Styles.confirmationText}>Are you sure?</div>
            <div className={Styles.confirmationButtons}>
              <Button onPress={close} variant="secondary" size="md">
                Cancel
              </Button>
              <Button onPress={handleDelete} size="md" frontIcon={DeleteIcon} iconClassName={Styles.deleteIcon}>
                Delete
              </Button>
            </div>
          </div>
        )
      }}
    </DropdownTrigger>
  )
}
